import React from 'react';
import { 
  Box, 
  Typography, 
  Divider, 
  Avatar,
  IconButton,
  Tooltip
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { formatDateHour } from '../../utils/lib';
import { useTranslation } from 'react-i18next';

const ListItemAgendaReport = ({ agenda, onReschedule, onComplete, onClick }) => {
  const { t } = useTranslation();
  const handleClick = (e) => {
    if (e.target.closest('button')) {
      return;
    }
    onClick && onClick(agenda);
  };

  return (
    <Box>
      <Box 
        sx={{ 
          display: 'flex', 
          p: 1, 
          alignItems: 'center',
          cursor: onClick ? 'pointer' : 'default',
          '&:hover': onClick ? { bgcolor: 'action.hover' } : {}
        }}
        onClick={handleClick}
      >
        <Avatar 
          sx={{ width: 30, height: 30, bgcolor: 'transparent' }}
        >
          <AccessTimeIcon fontSize="small" color="action" />
        </Avatar>
        
        <Box sx={{ flex: 1, ml: 1, overflow: 'hidden' }}>
          <Typography 
            variant="body1" 
            sx={{ 
              fontSize: '14px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {`${formatDateHour(agenda.begin_time)} - ${agenda.event_name}`}
          </Typography>
          
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: '12px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: 'text.secondary'
            }}
          >
            {`${agenda.user?.name || ""}`}
          </Typography>
          
          {agenda.pet && (
            <Typography 
              variant="body2" 
              sx={{ 
                fontSize: '12px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {agenda.owner
                ? t('reports.petOfOwnerLabel', { pet: agenda.pet.name, owner: agenda.owner.name })
                : agenda.pet.name}
            </Typography>
          )}
        </Box>
        
        <Box sx={{ display: 'flex' }}>
          {agenda.executed === 0 && (
            <>
              <Tooltip title={t('agenda.reschedule')}>
                <IconButton 
                  onClick={(e) => { 
                    e.stopPropagation(); 
                    onReschedule && onReschedule(agenda);
                  }}
                  size="small"
                >
                  <ArrowForwardIcon />
                </IconButton>
              </Tooltip>
              
              <Tooltip title={t('agenda.complete')}>
                <IconButton 
                  onClick={(e) => { 
                    e.stopPropagation(); 
                    onComplete && onComplete(agenda);
                  }}
                  size="small"
                >
                  <CheckIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>
      </Box>
      
      <Divider sx={{ mx: 1 }} />
    </Box>
  );
};

export default ListItemAgendaReport;
